import { cn } from '@/lib/utils'
import { RoleAvatar, type Role } from './RoleCard'

interface Player {
  id: string
  name: string
  role: Role
}

interface TeamRosterProps {
  players: Player[]
  currentPlayerId: string
  className?: string
}

export function TeamRoster({ players, currentPlayerId, className }: TeamRosterProps) {
  return (
    <div className={cn('space-y-6', className)}>
      <div>
        <h2 className="text-2xl font-bold mb-2 text-[#12356B]">Team Roster</h2>
        <p className="text-base text-slate-600">
          Your teammates for this mission ({players.length} members)
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 rounded-2xl border border-[#CED4DE] bg-white p-4 shadow-sm">
        {players.map((player) => (
          <RoleAvatar
            key={player.id}
            role={player.role}
            name={player.name}
            isCurrentPlayer={player.id === currentPlayerId}
          />
        ))}
      </div>
    </div>
  )
}
